import { useTranslation } from 'react-i18next';

/** What the strip occupies above the game, until the build reports a height of its own. */
export const ControlsStripHeight = 44;

interface ControlsStripProps {
  buildUrl: string;
  width: number;
}

export default function ControlsStrip({ buildUrl, width }: ControlsStripProps) {
  const { t } = useTranslation();

  return (
    <iframe
      src={`${buildUrl}/editor/index.html#controls`}
      title={t('editor.controls')}
      style={{ width, height: ControlsStripHeight, border: 'none' }}
    />
  );
}
